<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_table_of_contents_1"><span>Downpayment</span></h1>
<p class="P_Normal__And__Left_Alignment__And__Left_Indent">By AJ Mars</p>
<p class="P_Normal__And__Left_Alignment__And__Left_Indent"> </p>
<p class="P_Normal">Mike Barrow and his friends are among many boys in Manchester who think the city will be their chance to improve themselves. But for now Mike is living in a damp flat with his friend Callum, and they’re both making ends meet by working the streets. When Mike meets Chris Wildsmith, a late-twenties entrepreneur, he thinks he’s hooked a job that will pay his rent for several weeks—a windfall already.</p>
<p class="P_Normal">But his connection with Chris quickly goes beyond what’s normal between rent boy and client. Mike meets Chris’s friends, goes to Chris’s parties with him as his “boyfriend,” and finds himself swept up in a world he’s never known. He’s sure it’s all going to go horribly wrong, and when Chris’s work colleague figures them out and becomes violent, he’s almost proven right. But Mike isn’t the only one who has confused professionalism with something else. The breakup that follows gives Mike the impetus he needs to relaunch himself as somebody else, a man who will hopefully be someone Chris very much wants to be with.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0001.vue?0a041f6a